import { useState } from 'react'
import { useAsync } from 'react-use'
import { useTranslate } from 'hooks/translate'
import Styled from './styled'
import Button from 'components/Button'
import Card from 'components/Card'
import Table from 'components/Table'
import { InputNumber, Space, notification } from 'antd'
import { getCloseMatch } from 'services/close_match'

export default function MatchIncident ({ defaultAmountOfReturn = 1, reportHeaderId, disabled }) {
  const { t } = useTranslate()
  const [dataSource, setDataSource] = useState([])
  const [close_match_loading, setCloseMatchLoading] = useState(false)
  const [amount_of_return, setAmountOfReturn] = useState(defaultAmountOfReturn)
  const columns = [
    {
      title: t('Topic'),
      dataIndex: 'topic',
      key: 'topic',
    },
    {
      title: t('Reporter'),
      dataIndex: 'reporter',
      key: 'reporter',
    },
    {
      title: t('Risk Owner'),
      dataIndex: 'risk_owner',
      key: 'risk_owner',
    },
    {
      title: t('Report Type'),
      dataIndex: 'report_type',
      key: 'report_type',
    },
    {
      title: t('Close Match'),
      dataIndex: 'close_match',
      key: 'close_match',
    },
  ]

  const _list = async (amount_of_return) => {
    if (close_match_loading) return

    setCloseMatchLoading(true)

    const res = await getCloseMatch(reportHeaderId, { amount_of_return: amount_of_return })

    setCloseMatchLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }

    setDataSource(res.data)
  }

  const onChangeAmountOfReturn = (value) => {
    setAmountOfReturn(value)
  }

  // useAsync(async () => {
  // _list(amount_of_return)
  // }, [])

  return (
    <Styled>
      <Card
        title={'Match Close'}
        titleExtra={
          <Space>
            <InputNumber
              size='middle'
              value={amount_of_return}
              controls={true}
              onChange={onChangeAmountOfReturn}
            ></InputNumber>
            <Button
              type='primary'
              style={{ background: 'purple', borderColor: 'purple' }}
              onClick={() => {
                _list(amount_of_return)
              }}
            >
              {'Get Close Match'}
            </Button>
          </Space>
        }
      >
        <Table
          className='macth'
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          scroll={{ x: 1200 }}
        ></Table>
      </Card>
    </Styled>
  )
}
